import React, { useEffect } from 'react';
import { CircularProgress, Stack, Text } from '@chakra-ui/react';
import { tccsLogin } from '../Utils/api';
import { useHistory } from 'react-router-dom';

export default function TccsOauth() {
  const history = useHistory();

  useEffect(() => {
    getUser();
  });

  function getUser() {
    let parse = new URL(location.href);
    let param = parse.searchParams;
    if (param.get('state') === '200') {
      getAccessToken(param.get('client_id'), param.get('data'));
    } else history.push('/');
  }

  function getAccessToken(client_id, data) {
    tccsLogin(client_id, data)
      .then((res) => {
        sessionStorage.clear();
        sessionStorage.setItem('token', JSON.stringify(res.token.access_token));
        sessionStorage.setItem('place_no', JSON.stringify(res.place_no));
        sessionStorage.setItem('company_no', JSON.stringify(res.company_no));
        history.push('/home');
      })
      .catch((err) => {
        console.log(err);
        history.push('/');
      });
  }

  return (
    <Stack alignItems="center" justifyContent="center" height="90vh">
      <Text marginBottom="5vh" fontSize="30px">
        TCCS 登入驗證中...
      </Text>
      <CircularProgress isIndeterminate color="#07B464" size="100px" />
    </Stack>
  );
}
